<div class="cb-tasks-form">
  @for (objective of selectedObjectives(); track objective.name) {
    <div class="task-group">
      <div class="objective-header">
        <div class="objective-indicator">
          <div class="short-orange-line"></div>
        </div>
        <h3 class="objective-title">{{ objective.name }}</h3>
      </div>

      <div class="tasks-list">
        @for (option of optionsByObjective()[objective.name]; track option.uid) {
          <cb-checkbox-option
            [option]="option"
            [inputValue]="tasksByObjective()[objective.name]?.[option.inputIndex!]?.name ?? ''"
            [hasError]="!!duplicateIndicesByObjective()[objective.name]?.has(option.inputIndex!)"
            [removable]="!!hasMultipleTasks()[objective.name]"
            (valueChange)="onTaskToggle(objective.name, option, $event)"
            (inputChange)="onInputChange(objective.name, $event, option.inputIndex ?? 0)"
            (remove)="onRemoveTask(objective.name, option.inputIndex!)"
          ></cb-checkbox-option>
        }
      </div>
    </div>
  }
</div>
